import config from './config';

const accountUrl = config.accountUrl;
const httpProtocol = config.httpProtocol;
// 检查是否已登录
// 
function getCookie(name) {
  var nameTemp = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameTemp) == 0) {
      return c.substring(nameTemp.length, c.length);
    }
  }
  return null;
}

function deleteCookie() {
  return document.cookie = "_sw_token=" +
    ";path=/" +
    ";domain=.shuwen.com" +
    ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

function addCookie(name, value) {
  var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

// 特殊逻辑，如果不存在特定cookie, 则立刻显示登录的按钮
const swToken = getCookie('_sw_token');

if (!swToken) {
  showLogin();
}

getAccountInfo();

function getAccountInfo() {
  return;
  $.ajax({
    url: httpProtocol + accountUrl + '/api/uic/get/user.json',
    jsonp: 'callback',
    dataType: 'jsonp',
    success: (data) => {
      if (data && data.code === 'SW-010000') {
        getUserInfo(data.data);
      } else {
        // 没有检测到是否登录
        showLogin();
      }
    },
    error: (err) => {
      showLogin();
    }
  });
}

function getUserInfo(userData) {
  return;
  $.ajax({
    url: '/api/account/getUserInfo',
    dataType: 'json',
    success: (data) => {
      const resData = data.data;
      if (resData && resData.userInfo) {

        // 设置用户名
        $('.item-user-nick').text(userData.nickname || resData.userInfo.userName || resData.userInfo.mobile);

        if (resData.businessInfo.businessId) {
          $('.item-ent-name').text(resData.businessInfo.businessName || '机构名称设置错误');
        } else {
          $('.entname').text('未绑定任何机构');
        }
        if (resData.userInfo.userType === 'M') {
          getUserList();
        } else {
          $('.last-item').hide();
          $('.entname').addClass('ext');
        }

        // setTimeout(() => {
          showUserInfo();
        // }, 100);

      } else {
        showLogin();
      }
    },
    error: (err) => {
      showLogin();
    }
  });
}

function getUserList() {
  $.ajax({
    url: '/api/account/listInvitation?current=1&size=1',
    dataType: 'json',
    success: (data) => {
      // 设置成员数量
      if (data && data.data) {
        $('.last-item').show();
        $('.item-ent-count').text(data.data.total || 1);

        const isViewed = getCookie('manageguide');
        if (!isViewed) {
          $('.tipsPoint').show();
          $('.tipsPoint2').show();
        } else if (isViewed === '1') {
          $('.tipsPoint2').show();
        }
      } else {
        $('.last-item').hide();
        $('.entname').addClass('ext');
      }
    },
    error: (err) => {
      showLogin();
    }
  });
}

function showUserInfo() {
  $('.loginActions').hide();
  $('.userActions').show();
}

function showLogin() {
  $('.loginActions').show();
  $('.userActions').hide();
}

// 登出逻辑
$('.logout').click(() => {
  $.ajax({
    url: '/api/account/logout',
    method: 'POST',
    dataType: 'json',
    success: (data) => {
      // 设置成员数量
      deleteCookie();
      showLogin();
    },
    error: (err) => {
      deleteCookie();
      showLogin();
    }
  });
});

$('.manage').click(() => {
  const isViewed = getCookie('manageguide');
  if (!isViewed || isViewed === '1') {
    addCookie('manageguide', '2');
    $('.tipsPoint2').hide();
  }
});

$('.userActions').hover(() => {
  const isViewed = getCookie('manageguide');
  if (!isViewed) {
    addCookie('manageguide', '1');
    $('.tipsPoint').hide();
  }
})



// WEBPACK FOOTER //
// ./src/pages/user.js